export function encodeUrl(url: string) {
	return encodeURIComponent(url)
		.replace(/~/g, '%7E')
		.replace(/\*/g, '%2A')
		.replace(/!/g, '%21')
		.replace(/'/g, '%27')
		.replace(/\(/g, '%28')
		.replace(/\)/g, '%29');
}
